import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Card } from "./ui/card";
import { BellRinging, Warning, ArrowRight, Ruler, HardHat } from "@phosphor-icons/react";

const OPZIONI = [3, 7, 15, 30];

export default function AdempimentiImminenti() {
  const [giorni, setGiorni] = useState(() => Number(localStorage.getItem("promemoria_giorni") || 7));
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/dashboard/adempimenti-imminenti?giorni=${giorni}`)
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, [giorni]);

  if (!data || data.totale === 0) return null;

  return (
    <Card className="p-4 border-amber-200 bg-amber-50/40" data-testid="adempimenti-imminenti">
      <div className="flex items-start gap-2 flex-wrap">
        <BellRinging size={18} className="text-amber-700 mt-0.5" weight="fill" />
        <div className="flex-1 min-w-[180px]">
          <div className="text-sm font-semibold text-slate-900">Adempimenti da registrare</div>
          <div className="text-[11px] text-slate-600">
            {data.totale} in scadenza entro {giorni} giorni
            {data.scaduti > 0 && <span className="text-red-700 font-semibold"> · {data.scaduti} già oltre la data prevista</span>}
          </div>
        </div>
        <div className="flex items-center gap-1">
          {OPZIONI.map((g) => (
            <button
              key={g}
              onClick={() => { setGiorni(g); localStorage.setItem("promemoria_giorni", String(g)); }}
              className={`text-[10px] font-mono px-2 py-1 rounded border transition-colors ${giorni === g ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"}`}
              data-testid={`promemoria-giorni-${g}`}
            >
              {g}gg
            </button>
          ))}
        </div>
      </div>

      <div className="mt-3 space-y-1.5">
        {data.items.slice(0, 6).map((a) => (
          <Link
            key={`${a.pratica_id}-${a.codice}`}
            to={`/pratiche/${a.pratica_id}`}
            className="flex items-center gap-2 p-2 rounded-lg bg-white border border-slate-200 hover:border-slate-900 transition-colors group"
            data-testid={`adempimento-${a.codice}`}
          >
            <span className={`text-[9px] font-mono uppercase px-1.5 py-0.5 rounded border shrink-0 ${a.ruolo === "DL" ? "bg-blue-100 text-blue-800 border-blue-200" : "bg-orange-100 text-orange-800 border-orange-200"}`}>
              {a.ruolo === "DL" ? <Ruler size={9} className="inline mr-0.5" /> : <HardHat size={9} className="inline mr-0.5" />}
              {a.ruolo}
            </span>
            <div className="flex-1 min-w-0">
              <div className="text-[12px] font-medium text-slate-900 truncate">{a.nome}</div>
              <div className="text-[10px] text-slate-500 truncate">
                {a.cliente_nome || a.pratica_titolo} · <span className="font-mono">{a.riferimento}</span>
              </div>
            </div>
            <div className="text-right shrink-0">
              <div className={`text-[11px] font-semibold tabular-nums ${a.scaduto ? "text-red-700" : a.giorni_rimanenti <= 3 ? "text-amber-700" : "text-slate-700"}`}>
                {a.scaduto
                  ? <span className="inline-flex items-center gap-1"><Warning size={11} /> {Math.abs(a.giorni_rimanenti)}gg fa</span>
                  : `tra ${a.giorni_rimanenti}gg`}
              </div>
              <div className="text-[10px] text-slate-400 font-mono">{new Date(a.data_prevista).toLocaleDateString("it-IT")}</div>
            </div>
            <ArrowRight size={13} className="text-slate-300 group-hover:text-slate-900 shrink-0" />
          </Link>
        ))}
      </div>
      {data.totale > 6 && (
        <div className="text-[10px] text-slate-500 mt-2">e altri {data.totale - 6} adempimenti · apri il cantiere dell&apos;incarico per registrarli</div>
      )}
    </Card>
  );
}
